<template>
  <div
    v-if="isShow"
    role="dialog"
    aria-modal="true"
    aria-labelledby="dialogTitle"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3
        id="dialogTitle"
        class="ml-6 mt-7 mb-4"
      >
        {{ $t('messages.apple_signin_fail_modal.title') }}
      </h3>
      <p class="ml-6 mr-6 mb-5 text-zyxel-gray-800">
        {{ $t('messages.apple_signin_fail_modal.description') }}
      </p>
      <a
        class="ml-6 b1 text-zyxel-green-700 cursor-pointer"
        href="https://community.zyxel.com/en/discussion/22669/resolve-the-issue-as-continue-with-apple-sign-in-failure/p1?new=1"
        target="_blank"
      >
        {{ $t('messages.apple_signin_fail_modal.link') }}
      </a>
      <div class="modal-footer hidden sm:flex justify-end">
        <button
          class="ml-3 mb-4 mr-4 button-cancel min-w-[120px]"
          @click="close"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
      <div class="modal-footer flex-col sm:hidden p-6">
        <button
          class="button-cancel w-full mb-4"
          @click="close"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "AppleSigninFailDialog",
    props: {
      isShow: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      goToUrl(url) {
        window.open(url, '_blank');
      }
    }
}
</script>